import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { UserStore } from "../store/user.store";

export function authErrorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const userStore = inject(UserStore);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Expired / missing session cookie — skip auth endpoints so that a wrong
      // password on the sign-in form does not trigger a redirect loop.
      const isAuthEndpoint = req.url.includes("/api/auth/");
      if (error.status === 401 && !isAuthEndpoint) {
        userStore.clear();
        router.navigate(["/sign-in"]);
      }

      // Only redirect navigation errors on GET requests — POST/PATCH/DELETE errors
      // must surface inline so forms can display validation and failure messages.
      if (req.method === "GET") {
        if (error.status === 404) router.navigate(["/404"]);
        if (error.status === 403) router.navigate(["/403"]);
        if (error.status >= 500) router.navigate(["/500"]);
      }

      return throwError(() => error);
    })
  );
}
